import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Contact } from "@fleet/icons";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { CrmTabs } from "@/features/crm/crm-tabs";
import { CrmKanban } from "@/features/crm/crm-kanban";
// AUTONOMY · Layer 3: CRM contextual help.

function CrmPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="6xl">
      <div class="flex items-start justify-between gap-2">
        <PageHeader
          title={t(msg`CRM`)}
          description={t(
            msg`Every prospective student from first contact to enrollment: drag leads across stages, log follow-ups and reach out via WhatsApp or email campaigns.`,
          )}
          icon={Contact}
        />
      </div>
      <div class="mt-4">
        <CrmTabs />
        <CrmKanban />
      </div>
    </PageContainer>
  );
}

export const crmRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/crm",
  component: withFeatureGate("crm.leads", CrmPage),
});
